<template>
  <div class="col-lg-12 text-center fixed-top">

    <div class="col-lg-12 text-center" style="z-index: 1050;">
      <img style="" class="col-lg-4 d-block ml-auto mr-auto  text-center"
           :src="findAttributeOnSiteInfo('loadingIcon')[0]"
           :alt="findAttributeOnSiteInfo('site_name')[0]">

      <img style="" class="col-lg-1 d-block ml-auto mr-auto  text-center"
           :src="require('../assets/dots-loader.gif')"
           :alt="findAttributeOnSiteInfo('site_name')[0]">
    </div>

    <!--          <b-spinner class="mt-5 d-block" style="width: 7rem; height: 7rem; color: var(&#45;&#45;primary);"
                         label="Large Spinner"/>-->


  </div>
</template>

<script>
export default {
name: "Loading"
}
</script>

<style scoped>

</style>